import { Row, Col, FormGroup, Label, Input } from 'reactstrap';
import WaterwayItemTypeView from '../ItemsView/WaterwayItemTypeView';
import FreshWaterIrrigationItemTypeView from '../ItemsView/FreshWaterIrrigationItemTypeView';
import ItemTypeView from '../ItemsView/ItemTypeView';
import ItemTypeListView from '../ItemsView/ItemTypeListView';
import WinterGrazingItemTypeListView from '../ItemsView/WinterGrazingItemTypeListView';
import LargeFarmView from './LargeFarmView';
import Documents from '../Uploads/Documents';
import ActionsToConsider from '../FarmApt/ActionsToConsider';
import WholeFarmActionView from './WholeFarmActionView';
import HistoricalActions from './HistoricalActions';
import uuid from 'react-uuid';
import WinterGrazingItemView from './WinterGrazingItemView';
const NonMapView = ({ handleBlockOnlySelect, handleBlockZoomlevelSave, blockOnly,handleBlockZoomlevel,handleCenterPinClick,mapDetails, handleHideChildrenCheck, hideChildren, toggleChildItemState, handleChildItemToggle,handleSectionCommentChange,itemModel, handleClearSelection, toggleItemTypeListState, toggleItemTypeState, toggleItemState,
    handleItemClick, handleItemEditPopup, handleItemDeletePopup, handleOpenActionPopup, largeEnterpriseDetails, handleLMUSelectChange,
    handleItemTypeListTogole, handleItemTypeTogole, handleItemTogole, sectionObj, handleItemHighlight, outlineCenter, handleOpenWholeActionPopup, isWizardCompleted, show_HistoricalActions
    , luDisplay, handleLUDisplayChange, luDisplayDisabled, handleShowWaterTakeitems, toggleShowCenterPin
}) => {

    const itemList = itemModel.itemList;
    const itemTypesList = itemModel.itemTypes;
    const uniqueItemTypesList = itemModel.uniqueItemTypes;
    const Section = itemModel.Section;
    return (
        <Row>
            
            <Col sm="12">
                {Section != 'Winter Grazing' && Section != 'Community & Cultural Significance' && Section != 'WaterwaysMap' && Section != 'WaterwaysRisk'
                    && Section != 'InfrastructureRisk' && Section != 'InfrastructureMap'
                    && Section != 'IrrigationRisk' && Section != 'IrrigationMap' && Section != 'Land and Erosion'
                    && Section != 'EffluentDisposalRisk' && Section != 'EffluentDisposalMap' &&
                    <LargeFarmView largeEnterpriseDetails={largeEnterpriseDetails} handleLMUSelectChange={handleLMUSelectChange}></LargeFarmView>
                }
                {
                    (itemModel.isMapOnly || itemModel.isMapRisk) && Section != "Winter Grazing"  && Section != "Community & Cultural Significance" && 
                    <>
                        <ItemTypeListView isWizardCompleted={isWizardCompleted} Section={Section}
                            itemTypesList={itemTypesList}
                            toggleItemTypeListState={toggleItemTypeListState}
                            handleClearSelection={handleClearSelection}
                            handleItemClick={handleItemClick}
                            handleItemTypeListTogole={handleItemTypeListTogole}
                        >
                        </ItemTypeListView>
                        <br />
                    </>
                }
                {
                    Section == "Winter Grazing" && 
                    <>
                        <WinterGrazingItemTypeListView isWizardCompleted={isWizardCompleted} Section={Section}
                            itemTypesList={itemTypesList}
                            toggleItemTypeListState={toggleItemTypeListState}
                            handleClearSelection={handleClearSelection}
                            handleItemClick={handleItemClick}
                            handleItemTypeListTogole={handleItemTypeListTogole}
                        >
                        </WinterGrazingItemTypeListView>
                        <br />
                    </>
                }
                {(Section == 'InfrastructureRisk' || Section == 'InfrastructureMap' || Section == 'Land and Erosion'
                    || Section == 'WaterwaysMap' || Section == 'WaterwaysRisk'
                    || Section == 'EffluentDisposalRisk' || Section == 'EffluentDisposalMap'
                    || Section == 'IrrigationRisk' || Section == 'IrrigationMap' 
                ) &&
                    <LargeFarmView largeEnterpriseDetails={largeEnterpriseDetails} handleLMUSelectChange={handleLMUSelectChange}></LargeFarmView>
                }
                {( Section == 'EffluentDisposalRisk' || Section == 'EffluentDisposalMap'
                ) &&
                    <>
                        <Label className="">LU Display</Label>&nbsp;&nbsp;&nbsp;&nbsp;
                        <select className="form-select1" value={luDisplay} onChange={handleLUDisplayChange} disabled={luDisplayDisabled}>
                            <option value="None">None</option>
                            <option value="Irrigated Only">Effluent Only</option>
                            <option value="All">All</option>
                        </select>
                    </>
                }
                {(Section == 'IrrigationRisk' || Section == 'IrrigationMap'
                ) &&
                    <>
                    <Input className="" type="checkbox" checked={itemModel.showWaterTakeitems} onChange={handleShowWaterTakeitems} name="showWaterTakeitems" id="showWaterTakeitems" />
                    {'   '}<Label className="">Show freshwater irrigation water takes</Label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <Label className="">LU Display</Label>&nbsp;&nbsp;&nbsp;&nbsp;
                    <select className="form-select1" value={luDisplay} onChange={handleLUDisplayChange} disabled={luDisplayDisabled}>
                        <option value="None">None</option>
                        <option value="Irrigated Only">Irrigated Only</option>
                        <option value="All">All</option>
                    </select>
                    </>
                }
                {sectionObj.isWholeFarmActionRequired && !itemModel.isMapOnly &&
                    <>
                    <WholeFarmActionView outlineCenter={outlineCenter} handleOpenWholeActionPopup={handleOpenWholeActionPopup} open={false} showArrow={true}></WholeFarmActionView>
                        <br/>
                    </>
                }
                {
                    Section != "Community & Cultural Significance" && show_HistoricalActions && !itemModel.isMapOnly &&
                    <>
                        <HistoricalActions sectionId={sectionObj.id} open={false} showArrow={true}></HistoricalActions>
                        <br />
                    </>
                }
                {(Section == 'WaterwaysMap' || Section == 'WaterwaysRisk') &&
                    <>
                    {uniqueItemTypesList.map(type =>
                        itemList.filter(item => item.itemTypeName == type.name).length != 0 &&
                        <WaterwayItemTypeView handleHideChildrenCheck={handleHideChildrenCheck} toggleChildItemState={toggleChildItemState} handleChildItemToggle={handleChildItemToggle} hideChildren={hideChildren} key={type.uniqueName} itemList={itemList} itemType={type} itemTypesList={itemTypesList}
                            largeEnterpriseDetails={largeEnterpriseDetails}
                            toggleItemTypeState={toggleItemTypeState}
                            toggleItemState={toggleItemState}
                            handleItemEditPopup={handleItemEditPopup}
                            handleItemDeletePopup={handleItemDeletePopup}
                            handleOpenActionPopup={handleOpenActionPopup}
                            handleItemTypeTogole={handleItemTypeTogole}
                            handleItemTogole={handleItemTogole}
                            handleItemHighlight={handleItemHighlight} Section={Section} itemModel={itemModel}
                        >
                        </WaterwayItemTypeView>
                    )}
                    </>
                }
                {(Section == 'IrrigationRisk' || Section == 'IrrigationMap') &&
                    <>
                        {uniqueItemTypesList.map(type =>
                            itemList.filter(item => item.itemTypeName == type.name).length != 0 &&
                            <FreshWaterIrrigationItemTypeView handleHideChildrenCheck={handleHideChildrenCheck} toggleChildItemState={toggleChildItemState} handleChildItemToggle={handleChildItemToggle} hideChildren={hideChildren} key={type.uniqueName} itemList={itemList} itemType={type} itemTypesList={itemTypesList}
                                largeEnterpriseDetails={largeEnterpriseDetails}
                                toggleItemTypeState={toggleItemTypeState}
                                toggleItemState={toggleItemState}
                                handleItemEditPopup={handleItemEditPopup}
                                handleItemDeletePopup={handleItemDeletePopup}
                                handleOpenActionPopup={handleOpenActionPopup}
                                handleItemTypeTogole={handleItemTypeTogole}
                                handleItemTogole={handleItemTogole}
                                handleItemHighlight={handleItemHighlight} Section={Section} itemModel={itemModel}
                            >
                            </FreshWaterIrrigationItemTypeView>
                        )}
                    </>
                }
                {Section != 'Winter Grazing' && Section != 'WaterwaysMap' && Section != 'WaterwaysRisk' && Section != 'IrrigationRisk' && Section != 'IrrigationMap' &&
                    <>
                        {uniqueItemTypesList.map(type =>
                            itemList.filter(item => item.itemTypeName == type.name).length != 0 &&
                            <ItemTypeView key={type.uniqueName} itemList={itemList} itemType={type} itemTypesList={itemTypesList}
                                largeEnterpriseDetails={largeEnterpriseDetails}
                                toggleItemTypeState={toggleItemTypeState}
                                toggleItemState={toggleItemState}
                                handleItemEditPopup={handleItemEditPopup}
                                handleItemDeletePopup={handleItemDeletePopup}
                                handleOpenActionPopup={handleOpenActionPopup}
                                handleItemTypeTogole={handleItemTypeTogole}
                                handleItemTogole={handleItemTogole}
                                    handleItemHighlight={handleItemHighlight} Section={Section} itemModel={itemModel}
                            >
                            </ItemTypeView>
                        )}
                    </>
                }
                {
                    Section == 'Winter Grazing' &&
                    <>
                        {itemModel.itemList.filter(x => x.itemTypeName == 'Paddock').map(item =>
                            <WinterGrazingItemView handleBlockZoomlevelSave={handleBlockZoomlevelSave} blockOnly={blockOnly} handleCenterPinClick={handleCenterPinClick} mapDetails={mapDetails} key={uuid()} item={item} itemTypesList={itemTypesList}
                                toggleItemState={toggleItemState} handleBlockOnlySelect={handleBlockOnlySelect} handleBlockZoomlevel={handleBlockZoomlevel}
                                handleItemEditPopup={handleItemEditPopup}
                                handleItemDeletePopup={handleItemDeletePopup}
                                handleOpenActionPopup={handleOpenActionPopup}
                                handleItemTogole={handleItemTogole}
                                handleItemHighlight={handleItemHighlight}
                                Section={Section} itemModel={itemModel} toggleShowCenterPin={toggleShowCenterPin}
                            ></WinterGrazingItemView>
                        )}
                    </>
                }

                {/*Document Upload*/}
                {
                    sectionObj.isDocumentUploadReq && Section != 'Community & Cultural Significance' && Section != 'Biosecurity' && !itemModel.isMapOnly && <Documents refid={sectionObj.id} uploadType="Section" open={false} showArrow={true}></Documents>
                }

                {/*Actions to Consider*/}
                {
                    sectionObj.isFarmAPTActionsReq && !itemModel.isMapOnly && <ActionsToConsider sectionId={sectionObj.id} />
                }
            </Col>
        </Row>
    );
}
export default NonMapView